import { styled } from '@superset-ui/core';
import React, { useState } from 'react';
import { supersetTheme as theme } from '@superset-ui/core';
import downIcon from 'src/assets/images/datax/arrow-down-white.png';

export interface DataxDropdownOption {
    label: string;
    value: any;
}

interface Props {
    text: string;
    options: DataxDropdownOption[];
    onSelect: (value: any) => void;
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: end;
    position: relative;
`;

const Button = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: .5rem;
    padding: .5rem .8rem;
    cursor: pointer;
    background: #0046D9;
    border: none;
    border-radius: 4px;
    width: fit-content;

    // Color
    color: ${theme.colors.primary.base};
`;

const Panel = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: .5rem;
    width: 11rem;
    position: absolute;
    top: 2.7rem;
    background-color: white;

    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
`;

const Text = styled.div`
    display: flex;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.3rem;
    color: white;
`;

const OptionText = styled.div`
    display: flex;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.3rem;
    padding: .7rem;
    cursor: pointer;

    // Hover
    &:hover {
        background: #F5F8FF;
    }
`;

const Dropdown = (props: Props) => {
    const [ collapsed, setCollapsed ] = useState<boolean>(true);

    const toggle = () => setCollapsed(prev => !prev);

    return (
        <Container>
            <Button onClick={toggle}>
                <Text>{props.text}</Text>
                <img src={downIcon} alt=''></img>
            </Button>
            { !collapsed && (
                <Panel>
                    {
                        props.options.map(option =>
                            <OptionText id={option.value} onClick={() => props.onSelect(option.value)}>
                                {option.label}
                            </OptionText>)
                    }
                </Panel>
            )}
        </Container>
    );
};

export default Dropdown;